import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "./pages/Dashboard";
import IncomeTracker from "./pages/IncomeTracker";
import ExpenseTracker from "./pages/ExpenseTracker";
import DeductionsHub from "./pages/DeductionsHub";
import TaxCalculator from "./pages/TaxCalculator";
import Settings from "./pages/Settings";
import Navigation from "./components/Navigation";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-background">
        <Navigation />
        <main className="pb-16">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/income" element={<IncomeTracker />} />
            <Route path="/expenses" element={<ExpenseTracker />} />
            <Route path="/deductions" element={<DeductionsHub />} />
            <Route path="/calculator" element={<TaxCalculator />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </main>
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;